<template>
  <div
    class="select-input-box fb fb-main-between fb-cross-center h-56 lh-56 font-34"
    style="height: 56px; line-height: 56px"
    @click="handlerClick"
  >
    <!-- 弹性布局会导致溢出样式失效  fb fb-cross-center -->
    <span
      class="inline-block mr-12"
      :class="{ required: required, 'text-ellipsis': !required }"
      :style="`width:${labelWidth}px;`"
      v-html="label"
    ></span>
    <div class="fb fb-cross-center fb-main-center">
      <div v-if="showSlot" class="fb fb-cross-center c-171A1D-28">
        <slot name="commonRight"></slot>
      </div>
      <div v-else class="select-input-box-result c-171A1D-28">
        <span v-if="!value">{{ placeholder }}</span>
        <span
          v-else
          :style="{ 'max-width': `${maxWidth}px` }"
          class="showDetail"
          :class="[value === '请选择' ? '' : 'c-171A1D-80']"
          v-html="value"
        ></span>
      </div>
      <!-- <i v-show="showIcon" class="iconfont c-191F25-28">&#xe601;</i> -->
      <span
        v-show="showIcon"
        class="arrow-right"
        :class="{ ios: !isAdroid && value }"
      ></span>
    </div>
  </div>
</template>

<script>
import { IS_ANDROID } from '@/utils/comUtils'
export default {
  name: 'commonSelectInputBox',
  components: {},
  props: {
    label: String,
    value: {
      type: [String, Number],
      default: '请选择'
    },
    showIcon: {
      type: Boolean,
      default: true
    },
    maxWidth: {
      type: [String, Number],
      default: 200
    },
    required: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    labelWidth: {
      type: Number,
      default: 70
    },
    color: {
      type: Boolean,
      default: false
    },
    showSlot: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      date: '',
      isAdroid: IS_ANDROID
    }
  },
  computed: {},
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    this.init()
  },
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    init() {},
    handlerClick(e) {
      this.$emit('click', e)
    }
  },
  filters: {}
}
</script>

<style lang="scss" scoped>
.select-input-box {
  width: 100%;
  .select-input-box-result {
    // width: 150px !important;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding-right: 5px;
    text-align: right;
  }
}

.showDetail {
  display: inline-block;
  overflow: hidden;
  max-width: 200px;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
}
.arrow-right {
  background-image: url('~@/assets/images/icon_arrow_rigth.svg');
  width: 14px;
  height: 16px;
  background-size: 100% 100%;
  &.ios {
    margin-top: 3px;
  }
}
</style>
